export class DeliveryTermsDto{
    deliveryTermsId : number;
    deliveryTermsName : string;
    isActive: boolean;
    createdUser : string;
    
    /**
     * 
     * @param deliveryTermsId number
     * @param deliveryTermsName string
     * @param isActive boolean
     * @param createdUser string
     */
    constructor(deliveryTermsId : number,deliveryTermsName : string,isActive: boolean,createdUser : string){
        this.deliveryTermsId = deliveryTermsId;
        this.deliveryTermsName = deliveryTermsName;
        this.isActive= isActive;
        this.createdUser= createdUser;
    }
}
export const DeliveryTermsDtoDefault : DeliveryTermsDto = {
    deliveryTermsId: 0,
    deliveryTermsName: '',
    isActive: true,
    createdUser : '',


}; 